/* eslint-disable arrow-body-style */
import { curry } from 'lib/util'
import searchStepAndRecreate from 'app/_shared/events/searchStepAndRecreate'

/**
 * Event Handler Search Unsorted Step and Recreate
 *
 * Sets the event detail's value as current search term for the list of the current step and
 * recreates the module, so that it is taken into account the next time the list is rendered.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Gaia.PlatformEvent} event    information about the event that triggered this handler
 *
 * @returns {Promise<void>}
 */
const searchUnsortedStepAndRecreate = async (module, component, event) => {
  return searchStepAndRecreate(module, component, event, false)
}

export default curry(searchUnsortedStepAndRecreate)
